/* eslint-disable */
import {
    HubConnectionBuilder,
    HubConnection,
    LogLevel,
    HubConnectionState
} from '@microsoft/signalr'
import JwtService from "@/core/services/JwtService";

export class SignalRService
{
    private connection: HubConnection;

	constructor(
		retryDelays: number[] = [0, 2000, 10000, 30000]
	)
	{
		this.connection = new HubConnectionBuilder()
			.withUrl(
				process.env.VUE_APP_SIGNALR_API_URL == null ?
					"https://localhost:7171" : process.env.VUE_APP_SIGNALR_API_URL,
				{
					accessTokenFactory: () => {
						return JwtService.getToken() ?? "";
					}
				})
			.withAutomaticReconnect(retryDelays)
			.configureLogging(
				process.env.VUE_APP_SIGNALR_LOGGING == "debug" ? LogLevel.Debug : LogLevel.None)
			.build();

		// Adjust to server configuration
    	this.connection.keepAliveIntervalInMilliseconds = 10000;
    	this.connection.serverTimeoutInMilliseconds = 300000;
	}

	/**
     * Register connection callback's
     * @param onClose - on connection close callback
     * @param onReconnecting - on reconnecting callback
     * @param onReconnected - on reconnected callback (provides new connectionId)
     */
    registerConnectionCallbacks(onClose: (error?: Error) => void,
        onReconnecting: (error?: Error) => void,
        onReconnected: (connectionId?: string) => void): void
    {
        this.connection.onclose(onClose);
        this.connection.onreconnecting(onReconnecting);
        this.connection.onreconnected(onReconnected);
    }

	async start() {
		if (this.connection.state === HubConnectionState.Disconnected) {
			await this.connection.start();
		}
	}

	async stop() {
		await this.connection.stop();
	}
    // /**
    //  * @description  Init SignalR connection (without connect)
    //  */
    // public static init()
    // {
    //     this.connection = new HubConnectionBuilder()
    //         .withUrl(
    //             process.env.VUE_APP_SIGNALR_API_URL == null ?
    //                 "https://localhost:7171" : process.env.VUE_APP_SIGNALR_API_URL,
    //             {
    //                 accessTokenFactory: () => {
    //                     return JwtService.getToken() ?? "";
    //                 }
    //             })
    //         .configureLogging(
    //             process.env.VUE_APP_SIGNALR_LOGGING == "debug" ? LogLevel.Debug : LogLevel.None)
    //         .withAutomaticReconnect()
    //         .build();
    // }



    /**
     * Send message to corresponding methodName
     * @param methodName - method name to send data
     * @param args - data to send
     * @returns Promise evalueted when server respond on message
     */
	async sendMessage(methodName: string, ...args: any[]): Promise<void>
    {
        return this.connection.send(methodName, ...args);
    }

    /**
     * Invoke method on server and return coresponding data
     * @param methodName - method name to call
     * @param args - arguments to pass
     * @returns Promise evalueted when server respond on message
     */
    async invokeMethod<T = any>(methodName: string, ...args: any[]): Promise<T>
    {
        return this.connection.invoke(methodName, ...args);
    }

    /**
     * Register message
     * @param methodName
     * @param callback
     */
    registerMessageHandler(methodName: string,
        callback: (...args: any[]) => void)
	{
		console.error("Deprecated registerMessageHandler!", methodName);
        this.connection.on(methodName, callback);
    }

    /**
     * Unregister message handler.
     * Be sure that callback is the same object as registred before
     * even it cannot be removed
     * @param methodName - methodName
     * @param callback - callback to unregister
     */
    unregisterMessageHandler(methodName: string,
        callback: (...args: any[]) => void)
	{
		console.error("Deprecated unregisterMessageHandler!", methodName);
        this.connection.off(methodName, callback);
    }
}

export default SignalRService;